import React from 'react';
import { useParams } from 'react-router-dom';

// components
import CommCenter from '../../../../components/CommCenter';

/**
 * Project page sidebar. Carries the Brief tab on top of Attività and
 * Comunicazioni; clicking a cue tag highlights that cue in the cue sheet shown
 * next to it.
 */
const CommCenterProject = () => {
    const { projectId } = useParams();

    return (
        <CommCenter
            cueTarget="cuesheet"
            projectId={projectId}
            hasBrief/>
    )
}

export default CommCenterProject;
